export enum ActionPanelActionType {
    BeginDownloadFuf = "ActionPanel.BeginDownloadFuf",
    EndDownloadFuf = "ActionPanel.EndDownloadFuf",
    BeginDownloadInner = "ActionPanel.BeginDownloadInner",
    EndDownloadInner = "ActionPanel.EndDownloadInner",
}

export type ActionPanelAction =
    | {
          type: ActionPanelActionType.BeginDownloadFuf;
      }
    | {
          type: ActionPanelActionType.EndDownloadFuf;
      }
    | {
          type: ActionPanelActionType.BeginDownloadInner;
      }
    | {
          type: ActionPanelActionType.EndDownloadInner;
      };
